import { useParams } from "react-router-dom";
import StaffLayout from "@/pages/staff/StaffLayout";
import PatientProfileContent from "@/components/PatientProfileContent";

export default function StaffPatientProfilePage() {
  const { patientId } = useParams();
  return (
    <StaffLayout>
      <PatientProfileContent patientId={patientId} />
    </StaffLayout>
  );
}
